// ThemeToggle.js
import React from 'react';
import { Button, IconButton } from '@mui/material';

import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';

const ThemeToggle = () => {

  const [theme, setTheme] = React.useState(document.documentElement.getAttribute('data-theme'));

  const toggleTheme = () => {
    const newTheme = theme === 'dark' ? 'light' : 'dark';
    document.documentElement.setAttribute('data-theme', newTheme);
    setTheme(newTheme);
  };

  return (
    <IconButton onClick={toggleTheme}>
      { theme === 'dark' ? 
      <LightModeIcon sx={{ color: 'var(--background-color)'}} /> 
      : 
      <DarkModeIcon sx={{ color: 'var(--background-color)'}}/>
      }
    </IconButton>);
};

export default ThemeToggle;
